import { Component, Injector, ViewChild } from '@angular/core';
import { Art57Section } from '../../../shared/ui/Art57Section/Art57Section';
import { DetailedBulkUpdateViewComponent } from '../../../shared/component/detailed-view/detailed-bulk-update-view/detailed-bulk-update-view.component';
import { SectionService } from '../../../shared/service/section-service/section-service';
import { SectionName } from '../../../shared/ui/SectionName';

@Component({
  selector: 'app-bulk-update',
  templateUrl: './bulk-update.component.html',
  styleUrl: './bulk-update.component.scss'
})
export class BulkUpdateComponent {
  @ViewChild('detail_view_component') detail_view_component!: DetailedBulkUpdateViewComponent;
  
  constructor(
    public injector: Injector) {
    }

  initializeSection() {
    //Nothing to do
  }

  onResetApplication() {
    this.injector.get(Art57Section).resetApplication().then(applicationReseted => {
      if (applicationReseted) {
          this.injector.get(SectionService).loadSection(SectionName.bulkupdate);     
      }
    });
  }

  onResetSection() {
    this.injector.get(Art57Section).resetSection(this.injector.get(Art57Section).bulkupdate).then(sectionReseted => {
      if (sectionReseted) {
        this.initializeSection();
      }
    });
  }

  onRefresh(){
    
  }

  onButtonAction(buttonAction: any) {
    switch (buttonAction.action) {
      case 'resetApplication':
        this.onResetApplication();
        break;
      case 'resetSection':
        this.onResetSection();
        break;
      case 'refresh':
        this.onRefresh();
        break;
    }
  }

}
